import React from 'react';
import { Avatar, Badge, Box, Divider, IconButton, List, ListItem, ListItemButton, ListItemText, Theme, Tooltip, Typography, } from '@mui/material';
import NotificationPopover from './notification-popover.component';
import BasePopover from '../popover/base-popover.component';
import { cleanAccountCache } from '../../constants/tool.check-token';
import { Person2Outlined, ExitToAppOutlined, DarkMode, LightMode, Translate } from '@mui/icons-material';
import i18n from '../../i18n';
import { withStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import { DefaultWebsocketClient } from '../../modules/websocket/module';
import { GetThemeMode } from '../../themes/tool';
import { observer } from 'mobx-react-lite';
import { accountState } from '../../page/my-account/account-state';
import { createHashHistory } from 'history';
import TranslatePopover from '../popover/translate-popover';

export default observer(function ToolBarButton({
    // 是否显示头像
    showAvatar = true,
}: {
    showAvatar?: boolean;
}) {
    const [accountAnchorEl, setAccountAnchorEl] = React.useState<HTMLElement | null>(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = React.useState<HTMLElement | null>(null);
    const [translateAnchorEl, setTranslateAnchorEl] = React.useState<HTMLElement | null>(null);

    const { first_name, last_name, account_type } = accountState.userInfo || {};
    const themeMode = GetThemeMode();
    const name = `${first_name || ''} ${last_name || ''}`;

    const AvatarBadge = () => {
        return (<StyledBadge
            overlap='circular'
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            variant='dot'
        >
            <Avatar
                className='app-bar-avatar'
                alt={name}
                src={accountState.userInfo?.avatar} />
        </StyledBadge>)
    }

    return (
        <Box className='tool-bar-button'>
            <Box marginRight={4} sx={{ display: 'flex' }}>
                <Tooltip title={i18n.t('login_page_text_language')} className='tool-button'>
                    <IconButton
                        color='inherit'
                        onClick={(event) => {
                            setTranslateAnchorEl(event.currentTarget);
                        }}>
                        <Translate />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box marginRight={4} sx={{ display: 'flex' }}>
                <Tooltip title={i18n.t('general_text_switch_theme')} className='tool-button'>
                    <IconButton
                        color='inherit'
                        onClick={() => {
                            DefaultWebsocketClient.emit('SWITCH_THEME')
                        }}>
                        {themeMode === 'dark' ? <LightMode /> : <DarkMode />}
                    </IconButton>
                </Tooltip>
            </Box>
            {/* <Box marginRight={4} sx={{ display: 'flex' }}>
                <Tooltip title='Notifications' className='tool-button'>
                    <IconButton
                        aria-label="show new notifications"
                        color="inherit"
                        onClick={(event) => {
                            setNotificationAnchorEl(event.currentTarget);
                        }}>
                        <Badge badgeContent={1} color="primary">
                            <NotificationsNone />
                        </Badge>
                    </IconButton>
                </Tooltip>
            </Box> */}
            {
                showAvatar ?
                    <div onClick={(event: { currentTarget: any; }) => {
                        setAccountAnchorEl(event.currentTarget);
                    }}>
                        <AvatarBadge />
                    </div>
                    : null
            }
            <NotificationPopover
                open={Boolean(notificationAnchorEl)}
                anchorEl={notificationAnchorEl}
                onClose={() => {
                    // 消息通知popover关闭
                    setNotificationAnchorEl(null);
                }}
                // notifications={notices}
                newCount={0}
            />
            <BasePopover
                open={Boolean(accountAnchorEl)}
                anchorEl={accountAnchorEl}
                onClose={() => { setAccountAnchorEl(null) }}
                id='account-popover'
            >
                <Box minWidth={200}>
                    <List  >
                        <ListItem >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <AvatarBadge />
                                        <Box marginLeft={'0.625rem'}>
                                            <Typography variant='body1' fontWeight={600}>
                                                {name}
                                            </Typography>
                                            <Typography variant='body2' >
                                                {account_type}
                                            </Typography>
                                        </Box>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItem>
                        <Divider style={{ marginBottom: 8 }} />
                        <ListItemButton disableGutters={false}
                            onClick={() => {
                                createHashHistory().push('/main/account');
                            }}
                        >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <Person2Outlined style={{ marginRight: '8px', fontSize: 18 }} />
                                        <Typography >
                                            {i18n.t('main_page_text_person_page')}
                                        </Typography>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItemButton>
                        <ListItemButton disableGutters={false}
                            onClick={() => {
                                cleanAccountCache(true);
                            }}
                        >
                            <ListItemText
                                primary={
                                    <div className='FCS'>
                                        <ExitToAppOutlined style={{ marginRight: '8px', fontSize: 18 }} />
                                        <Typography >
                                            {i18n.t('main_page_button_sign_out')}
                                        </Typography>
                                    </div>
                                }
                                color='primary'
                            />
                        </ListItemButton>
                    </List>
                </Box>
            </BasePopover>
            <TranslatePopover
                anchorEl={translateAnchorEl}
                onClose={() => {
                    setTranslateAnchorEl(null);
                }}
            />
        </Box>
    )
})



// 头像徽章样式
const StyledBadge = withStyles((theme: Theme) =>
    createStyles({
        badge: {
            backgroundColor: '#44b700',
            color: '#44b700',
            boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
            '&::after': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                animation: '$ripple 1.2s infinite ease-in-out',
                border: '1px solid currentColor',
                content: '""',
            },
        },
        '@keyframes ripple': {
            '0%': {
                transform: 'scale(.8)',
                opacity: 1,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
    }),
)(Badge);